import { apiClient } from "../client";

export const requestOpenBanking = (sessionId: string) =>
  apiClient.post(`sessions/${sessionId}/open_banking`);
